<div style="overflow-x: auto;overflow-y: hidden; max-width: 100%;padding-bottom: 20px;">
    <table class="ui basic table">
        <thead>
            <tr>
                <!--<th></th>-->
                <th>
                    <span class='pointer' (click)="applyOrder('ot')"> OT </span>
                    <span [ngClass]="(filtros.orderBy.ot.apply) ? 'selected':''" *ngIf="filtros.orderBy.ot.apply">
                        <i (click)="changeOrder('ot','1')" *ngIf="filtros.orderBy.ot.value!='1'"
                            class="caret down icon pointer "></i>
                        <i (click)="changeOrder('ot','-1')" *ngIf="filtros.orderBy.ot.value!='-1'"
                            class="caret up icon pointer "></i>
                    </span>

                    <i [ngClass]="(filtros.ot) ? 'selected':''" (click)="toggleFilter('ot')"
                        class="filter icon icon-sm"></i>
                    <div class="popup" *ngIf="activeFilter === 'ot'">
                        <div class="ui fluid left input">
                            <input [(ngModel)]="filtros.ot" placeholder="Filtrar por OT" type="text">
                        </div>

                        <div class="btn-container">
                            <button (click)="cargarLista()" class="btn-white">FILTRAR</button>
                            <button (click)="limpiar('ot')" class="btn-white">BORRAR</button>
                        </div>
                    </div>
                </th>
                <th>
                    <span class='pointer' (click)="applyOrder('seccion')"> Sección </span>
                    <span [ngClass]="(filtros.orderBy.seccion.apply) ? 'selected':''"
                        *ngIf="filtros.orderBy.seccion.apply">
                        <i (click)="changeOrder('seccion','1')" *ngIf="filtros.orderBy.seccion.value!='1'"
                            class="caret down icon pointer "></i>
                        <i (click)="changeOrder('seccion','-1')" *ngIf="filtros.orderBy.seccion.value!='-1'"
                            class="caret up icon pointer "></i>
                    </span>

                    <i [ngClass]="(filtros.sections) ? 'selected':''" (click)="toggleFilter('section')"
                        class="filter icon icon-sm"></i>
                    <div class="popup" *ngIf="activeFilter === 'section'" >
                        <div class="ui input">
                            <input [(ngModel)]="filtros.sections" placeholder="Filtrar por Sección" type="text">
                        </div>

                        <div [style.margin]="'10px'">
                            <span class="value-p" *ngFor="let v of filtros.sections">
                                {{ v }}
                                <span class="clear-x" (click)="removeFilter('sections', v)"> x </span>
                            </span>
                        </div>

                        <div class="btn-container">
                            <!--<button [disabled]="!input.sections || input.sections.trim() === ''"
                                (click)="addFilter('sections')" class="btn-white">
                                AÑADIR
                            </button>-->
                            <button (click)="cargarLista()" class="btn-white">FILTRAR</button>
                            <button (click)="limpiar('sections')" class="btn-white">BORRAR TODO</button>
                        </div>
                    </div>


                </th>

                <th>
                    <span class='pointer' (click)="applyOrder('codigo')"> Código EMyR </span>
                    <span [ngClass]="(filtros.orderBy.codigo.apply) ? 'selected':''"
                        *ngIf="filtros.orderBy.codigo.apply">
                        <i (click)="changeOrder('codigo','1')" *ngIf="filtros.orderBy.codigo.value!='1'"
                            class="caret down icon pointer "></i>
                        <i (click)="changeOrder('codigo','-1')" *ngIf="filtros.orderBy.codigo.value!='-1'"
                            class="caret up icon pointer "></i>
                    </span>


                    <i [ngClass]="(filtros.codigoEstacion) ? 'selected':''" (click)="toggleFilter('codigoEmyr')"
                        class="filter icon icon-sm"></i>
                    <div class="popup" *ngIf="activeFilter === 'codigoEmyr'" >
                        <div class="ui input" style="margin-bottom: 5%;">
                            <input [(ngModel)]="filtros.codigoEstacion" placeholder="Filtrar por Código EMyR" type="text">

                        </div>


                        <div class="btn-container">
                            <button (click)="cargarLista()" class="btn-white">FILTRAR</button>
                            <button (click)="limpiar('codigoEstacion')" class="btn-white">BORRAR</button>
                        </div>
                    </div>


                </th>
                <th>
                    <span class='pointer' (click)="applyOrder('nombre')"> Nombre EMyR </span>
                    <span [ngClass]="(filtros.orderBy.nombre.apply) ? 'selected':''"
                        *ngIf="filtros.orderBy.nombre.apply">
                        <i (click)="changeOrder('nombre','1')" *ngIf="filtros.orderBy.nombre.value!='1'"
                            class="caret down icon pointer "></i>
                        <i (click)="changeOrder('nombre','-1')" *ngIf="filtros.orderBy.nombre.value!='-1'"
                            class="caret up icon pointer "></i>
                    </span>

                    <i [ngClass]="(filtros.nombre) ? 'selected':''" (click)="toggleFilter('nombre')"
                        class="filter icon icon-sm"></i>
                    <div class="popup" *ngIf="activeFilter === 'nombre'">
                        <div class="ui input" style="margin-bottom: 5%;">
                            <input [(ngModel)]="filtros.nombre" placeholder="Filtrar por Nombre EMyR" type="text">

                        </div>


                        <div class="btn-container">
                            <button (click)="cargarLista()" class="btn-white">FILTRAR</button>
                            <button (click)="limpiar('nombre')" class="btn-white">BORRAR</button>
                        </div>
                    </div>


                </th>
                <th>
                    <span class='pointer' (click)="applyOrder('fecha')"> Fecha y Hora</span>
                    <span [ngClass]="(filtros.orderBy.fecha.apply) ? 'selected':''" *ngIf="filtros.orderBy.fecha.apply">
                        <i (click)="changeOrder('fecha','1')" *ngIf="filtros.orderBy.fecha.value!='1'"
                            class="caret down icon pointer "></i>
                        <i (click)="changeOrder('fecha','-1')" *ngIf="filtros.orderBy.fecha.value!='-1'"
                            class="caret up icon pointer "></i>
                    </span>

                    <i [ngClass]="(filtros.startDate || filtros.endDate) ? 'selected':''"
                        (click)="toggleFilter('fecha')" class="filter icon icon-sm"></i>
                    <div class="popup" *ngIf="activeFilter === 'fecha'">
                        <div class="ui input filter-date" color="accent" appearance="outline">
                            <span class="label">
                                Desde :
                            </span> <input [(ngModel)]="filtros.startDate" type='date' placeholder="Desde">
                        </div>
                        <div class="ui input filter-date" color="accent" appearance="outline">
                            <span class="label">
                                Hasta :
                            </span>
                            <input [(ngModel)]="filtros.endDate" type='date' placeholder="Hasta">
                        </div>
                        <div class="btn-container">
                            <button (click)="cargarLista()" class="btn-white">FILTRAR</button>
                            <button (click)="limpiar('date')" class="btn-white">BORRAR</button>
                        </div>
                    </div>
                </th>
                <th>
                    <span class='pointer' (click)="applyOrder('frecuencia')">Frecuencia</span>
                    <span [ngClass]="(filtros.orderBy.frecuencia.apply) ? 'selected':''"
                        *ngIf="filtros.orderBy.frecuencia.apply">
                        <i (click)="changeOrder('frecuencia','1')" *ngIf="filtros.orderBy.frecuencia.value!='1'"
                            class="caret down icon pointer "></i>
                        <i (click)="changeOrder('frecuencia','-1')" *ngIf="filtros.orderBy.frecuencia.value!='-1'"
                            class="caret up icon pointer "></i>
                    </span>
                    <i [ngClass]="(filtros.frencuency) ? 'selected':''" (click)="toggleFilter('frecuencia')"
                        class="filter icon icon-sm"></i>
                    <div class="popup" *ngIf="activeFilter === 'frecuencia'">
                        <div class="ui input" style="margin-bottom: 5%;">
                           <!--<select [(ngModel)]="filtros.frencuency" class="ui selection dropdown">
                                <option value="" disabled selected hidden>Seleccione:Frecuencia</option>
                                <option value="Mensual">Mensual</option>
                            </select>-->
                            <input [(ngModel)]="filtros.frencuency" placeholder="Filtrar por Frecuencia" type="text">

                        </div>


                        <div class="btn-container">
                            <button (click)="cargarLista()" class="btn-white">FILTRAR</button>
                            <button (click)="limpiar('frencuency')" class="btn-white">BORRAR</button>
                        </div>
                    </div>
                </th>
                <th>
                    <span class='pointer' (click)="applyOrder('asignado')">Asignado a</span>
                    <span [ngClass]="(filtros.orderBy.asignado.apply) ? 'selected':''"
                        *ngIf="filtros.orderBy.asignado.apply">
                        <i (click)="changeOrder('asignado','1')" *ngIf="filtros.orderBy.asignado.value!='1'"
                            class="caret down icon pointer "></i>
                        <i (click)="changeOrder('asignado','-1')" *ngIf="filtros.orderBy.asignado.value!='-1'"
                            class="caret up icon pointer "></i>
                    </span>


                    <i [ngClass]="(filtros.username) ? 'selected':''" (click)="toggleFilter('asignado')"
                        class="filter icon icon-sm"></i>


                    <div class="popup" *ngIf="activeFilter === 'asignado'" >
                        <div class="ui input">
                            <!--<select class="ui selection dropdown" [(ngModel)]="input.username">
                                <option value="">Seleccione: Usuario</option>
                                <option *ngFor="let user of userFilters" [value]="user">{{ user }}</option>
                            </select>-->
                            <input [(ngModel)]="filtros.username" placeholder="Filtrar por Usuario" type="text">

                        </div>
                        <!--<div [style.margin]="'10px'">
                            <span class="value-p" *ngIf="filtros.username">
                                {{ filtros.username }}
                                <span class="clear-x" (click)="removeFilter('username', filtros.username)"> x </span>
                            </span>
                        </div>-->

                        <div class="btn-container">
                            <!--<button [disabled]="!input.username " (click)="addUniqueFilter('username')"
                                class="btn-white">
                                AÑADIR
                            </button>-->
                            <button (click)="cargarLista()" class="btn-white">FILTRAR</button>
                            <button (click)="limpiar('username')" class="btn-white">BORRAR TODO</button>
                        </div>
                    </div>
                </th>
                <th> </th>
                <th [style.min-width]="'50px'"></th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="assigned.length > 0; else noAssignedResults">
              <ng-container *ngFor="let item of assigned; index as i">
                <tr>
                  <td>{{ item.Status.OT?.Observed }}</td>
                  <td>{{ item.Status.Seccion?.Observed }}</td>
                  <td>{{ item.Status.CodigoEstacion?.Observed }}</td>
                  <td>{{ item.Status.DescriEstacion?.Observed }}</td>
                  <td>{{ item.When | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ item.Status.Frecuencia?.Observed }}</td>
                  <td>{{ item.Who[0]?.username }}</td>
                  <td>
                    <span class="state green" *ngIf="item.State == 'downloaded'">
                      DESCARGADA
                    </span>
                    <span class="state yellow" *ngIf="item.State == 'assigned'">
                      ASIGNADA
                    </span>
                  </td>
                  <td style="position: relative;" [style.min-width]="'50px'">
                    <button class="edit-btn" *ngIf="puedeCambiar(item)">
                      <i class="ellipsis vertical icon" (click)="toggleEdit(i)"></i>
                    </button>
                    <div *ngIf="activeEdit === i" class="popup pop-right">
                      <button
                        class="ui right labeled icon button button-filter primary"
                        *ngIf="item.State == 'assigned'"
                        (click)="desasignar(item._id)"
                        [class.no-pointer]="puedeCambiar(item)"
                      >
                        Desasignar
                      </button>
                      <button
                        class="ui right labeled icon button button-filter primary"
                        *ngIf="item.State == 'downloaded'"
                        (click)="asignar(item._id)"
                        [class.no-pointer]="puedeCambiar(item)"
                      >
                        Asignar
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          
            <ng-template #noAssignedResults>
              <tr>
                <td colspan="9" class="center aligned sin-resultados">No hay resultados.</td>
              </tr>
            </ng-template>
          </tbody>
          
    </table>
    <div class="ui grid" *ngIf='filtros.pageTotal >0 '>
        <div class="column centered row paginacion">
            <app-paginator2 #paginacion [size_page]="filtros.pageNumber" [totalElements]="filtros.totalItems"
                [pages_total]='filtros.pageTotal' (eventEmmiterChangePage)='changePageTable2($event)'>
            </app-paginator2>
        </div>
    </div>
</div>